import React, { useEffect, useState } from 'react';
import { STYLE_TYPE } from '../Utils/magicStrings';

export const styleContextApp = React.createContext('');

export const StyleContextApp = ({children}) => {
    const [ width, setWidth ] = useState(STYLE_TYPE.PC);

    const handleWindowResize = () => {
        if(window.innerWidth > 1440) {
            setWidth(STYLE_TYPE.BIG_PC);
        } else if (window.innerWidth <= 1440 && window.innerWidth > 700) {
            setWidth(STYLE_TYPE.PC);
        } else {
            setWidth(STYLE_TYPE.MOBILE);
        }
    }

    useEffect(() => {
        handleWindowResize();
        window.addEventListener('resize', handleWindowResize);
        return () => window.removeEventListener('resize', handleWindowResize);
    }, []);

    return (
        <styleContextApp.Provider value={width}>
            {children}
        </styleContextApp.Provider>
    );
}